




















































































































import {
   AusgabenDataModel,
   AusgabenZuZeitschriftAnchor,
} from "@/models/AusgabenDataModel";
import {
   BuchungenDataModel,
   BuchungenZuZeitschriftAnchor,
} from "@/models/BuchungenDataModel";
import { AusgabeEmptyCheckModel } from "@/models/AusgabeEmptyCheckModel";
import { FilialeModel } from "@/models/FilialeModel";
import { ProduktModel } from "@/models/ProduktModel";
import Vue from "vue";
import { ZeitschriftFlatModel } from "@/models/ZeitschriftDataModel";
import { catVue } from "@/util/logging";
import { mapState } from "vuex";

export default Vue.extend({
   // Component name for reference
   name: "PresseAnzeige",

   created() {
      catVue.info(`${this.$options.name}:: CREATED... `);
   },
   mounted() {
      catVue.info(
         `${this.$options.name}:: MOUNTED... props.produkt -> ${this.produkt.url}`
      );

      this.fetch();
   },
   data: () => ({
      ausgaben: [] as AusgabenDataModel[],
      loading: 0,
      buchungen: new Map<string, BuchungenDataModel | null>(),
      lastInFiliale: new Map<string, BuchungenDataModel | null>(),
      isEmptyMap: {} as Record<number, boolean>,
      inactiveLoading: 0 as number,
      inactivatingId: 0 as number,
   }),
   props: {
      produkt: Object,
   },
   computed: {
      filialen(): FilialeModel[] {
         catVue.info("Called. This.filialenAktiv = " + this.filialenAktiv);
         return this.filialenAktiv;
      },
      ...mapState("auth", ["theFiliale", "filialenAktiv"]),
   },
   methods: {
      //
      buchung(ausgabe: AusgabenDataModel): BuchungenDataModel | null {
         let ret = this.buchungen.get(ausgabe.uid);
         if (ret === undefined) ret = null;
         return ret;
      },
      //
      getLastInFiliale(filiale: FilialeModel): BuchungenDataModel | null {
         let ret = this.lastInFiliale.get(filiale.uid);
         if (ret !== undefined && ret !== null) return ret;
         return null;
      },
      //
      selectFiliale(fil: FilialeModel): void {
         this.$store.commit("auth/setFiliale", fil);
      },
      //
      verkauf(ausgabe: AusgabenDataModel): string | undefined {
         return this.buchung(ausgabe)?.verkaufStr;
      },
      //
      lfgDatum(ausgabe: AusgabenDataModel): string | undefined {
         return this.buchung(ausgabe)?.lieferungDatumStr;
      },
      //
      remiDatum(ausgabe: AusgabenDataModel): string | undefined {
         return this.buchung(ausgabe)?.remissionDatumStr;
      },
      //
      lfg(ausgabe: AusgabenDataModel): number | string {
         const b = this.buchung(ausgabe);
         if (null === b) return "-/-";
         let ret = 0;
         if (null !== b.hlfg) ret += b.hlfg;
         if (null !== b.nlfg) ret += b.nlfg;
         if (null !== b.diff) ret += b.diff;
         if (null !== b.iumb) ret += b.iumb;
         return ret;
      },
      //
      hasComplexDelivery(ausgabe: AusgabenDataModel): boolean {
         const b = this.buchung(ausgabe);
         if (null === b) return false;
         // Show tooltip if more than one component contributes to the total
         const components = [
            b.hlfg !== null && b.hlfg !== 0,
            b.nlfg !== null && b.nlfg !== 0,
            b.diff !== null && b.diff !== 0,
            b.iumb !== null && b.iumb !== 0,
         ];
         return components.filter((c) => c).length > 1;
      },
      //
      deliveryTooltip(ausgabe: AusgabenDataModel): string {
         const b = this.buchung(ausgabe);
         if (null === b) return "";
         const parts = [];
         if (b.hlfg !== null && b.hlfg !== 0)
            parts.push(`Hauptlieferung: ${b.hlfg}`);
         if (b.nlfg !== null && b.nlfg !== 0)
            parts.push(`Nachlieferung: ${b.nlfg}`);
         if (b.diff !== null && b.diff !== 0)
            parts.push(`Differenz: ${b.diff}`);
         if (b.iumb !== null && b.iumb !== 0)
            parts.push(`Interne Umbuchung: ${b.iumb}`);
         return parts.join("\n");
      },
      remi(ausgabe: AusgabenDataModel): number | string {
         const b = this.buchung(ausgabe);
         if (null === b || null === b.remi) return "-/-";
         return b.remi;
      },
      verk(ausgabe: AusgabenDataModel): number | string {
         const b = this.buchung(ausgabe);
         if (null === b || null === b.abvk) return "-/-";
         return b.abvk;
      },
      //
      async fetch() {
         this.loading++;
         if (null !== this.produkt && undefined !== this.produkt)
            AusgabenDataModel.forZeitschrift(
               this.produkt as ZeitschriftFlatModel,
               {
                  anchor: AusgabenZuZeitschriftAnchor.CURRENT_EVT,
               }
            )
               .then((ausgaben) => {
                  this.ausgaben = [];
                  this.ausgaben.push(...ausgaben);

                  this.fetchFiliale();
                  this.fetchLastBuchung();
                  this.checkAllAusgabenForEmpty();
                  this.loading--;
               })
               .catch((e: Error) => {
                  catVue.info("ERROR " + e);
                  this.loading--;
               });
      },
      //
      async fetchFiliale() {
         this.ausgaben.forEach((ausgabe) => {
            this.loading++;
            this.buchungen.set(ausgabe.uid, null);
            BuchungenDataModel.forAusgabeUndFiliale(ausgabe, this.theFiliale)
               .then((buchung) => {
                  this.buchungen.set(ausgabe.uid, buchung);
                  this.loading--;
               })
               .catch((e) => {
                  catVue.info("Error " + e);
                  this.loading--;
               });
         });
      },
      //
      async fetchLastBuchung() {
         this.filialen.forEach((filiale) => {
            this.loading++;
            this.lastInFiliale.set(filiale.uid, null);
            BuchungenDataModel.forZeitschriftUndFiliale(this.produkt, filiale, {
               count: 1,
               anchor: BuchungenZuZeitschriftAnchor.CURRENT_WARENEINGANG,
            })
               .then((buchungen: unknown) => {
                  if (Array.isArray(buchungen) && buchungen.length == 1)
                     this.lastInFiliale.set(filiale.uid, buchungen[0]);
                  this.loading--;
               })
               .catch((e: Error) => {
                  catVue.info("Error " + e);
                  this.loading--;
               });
         });
      },
      //
      async checkAllAusgabenForEmpty() {
         const uniqueAusgabenIds = new Set(
            this.ausgaben.map((a: { id: number }) => a.id)
         );
         const ausgabenArray = Array.from(uniqueAusgabenIds);
         for (let i = 0; i < ausgabenArray.length; i++) {
            const ausgabeId = ausgabenArray[i];
            try {
               const result = await AusgabeEmptyCheckModel.isEmptyCheck(
                  ausgabeId as number
               );
               this.$set(this.isEmptyMap, ausgabeId, result.isEmpty);
               if (result.isEmpty) {
                  catVue.info(
                     `Ausgabe ${ausgabeId} is empty - marked as inactive candidate`
                  );
               }
            } catch (error) {
               catVue.warn(
                  `isEmpty check failed for ausgabe ${ausgabeId}: ${error}`
               );
               this.$set(this.isEmptyMap, ausgabeId, false);
            }
         }
      },
      //
      async markAsInactive(ausgabeId: number, index: number) {
         this.inactiveLoading = ausgabeId;
         this.inactivatingId = ausgabeId; // Trigger fade animation
         try {
            await AusgabeEmptyCheckModel.markInactive(ausgabeId);

            // Wait for fade animation to complete
            await new Promise((resolve) => setTimeout(resolve, 600));
            this.ausgaben.splice(index, 1);

            // Clear the cache entry
            this.$delete(this.isEmptyMap, ausgabeId);

            catVue.info(`Ausgabe ${ausgabeId} successfully marked as inactive`);
            this.$root.$emit("showSnackbar", {
               message: "Ausgabe als inaktiv markiert",
               color: "success",
            });
         } catch (error) {
            catVue.warn(
               `Failed to mark ausgabe ${ausgabeId} as inactive: ${error}`
            );
            this.inactivatingId = 0; // Reset on error
            this.$root.$emit("showSnackbar", {
               message: `Fehler beim Inaktivieren: ${error}`,
               color: "error",
            });
         } finally {
            this.inactiveLoading = 0;
         }
      },
   },
   watch: {
      theFiliale(to: FilialeModel, from: FilialeModel): void {
         catVue.info(
            `${this.$options.name}:: theFiliale '${from.uid}' > '${to.uid}' `
         );
         this.fetchFiliale();
      },
      produkt(to: ProduktModel, from: ProduktModel): void {
         catVue.info(
            `${this.$options.name}:: produkt '${from.uid}' > '${to.uid}' `
         );
         this.fetch();
      },
   },
});
